import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { EnrollmentAcceptedStudentService } from 'src/app/service/enrollmentAcceptedStudent.service';
import { FileService } from 'src/app/service/file.service';
import { CoursesService } from 'src/app/service/courses.service';


import { environment } from 'src/environments/environment';
import { Console } from 'console';
import { EnrollmentGroupService } from 'src/app/service/enrollment-group.service';
import { AttendanceService } from 'src/app/service/attendance.service';
import { ThisReceiver } from '@angular/compiler';
import { forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

// Excel sheet export
import { Cell, Workbook } from 'exceljs';
import * as fs from 'file-saver';
import { decimalDigest } from '@angular/compiler/src/i18n/digest';
import * as XLSX from 'xlsx';
import { ScoresService } from 'src/app/service/scores.service';
declare var $: any;
@Component({
  selector: 'app-review-and-release',
  templateUrl: './review-and-release.component.html',
  styleUrls: ['./review-and-release.component.scss']
})
export class ReviewAndReleaseComponent implements OnInit {


  select: any;
  showLoader: boolean = false;
  loadStudentDetails: boolean = false;
  uploadingRemark: boolean = false;
  Searched: boolean = false;
  studentCourses: any = [];
  studentCoursesOriginal: any = [];
  studentDetails: any = [];
  currentStudentCourseId: any;
  // examScoreFile: any;
  // examScoreFileName: any;

  years: any;
  semesters: any;
  batches: any;
  orgId: any;
  username: any;

  @ViewChild('closeEditRemarkPopup') private closeEditRemarkPopup: any;

  currentYear: any;
  currentSemester: any;
  currentBatch: any;
  currentStatus: any;
  currentCourseObj: any;

  urlSearchYear: any;
  urlSearchSemester: any;
  urlSearchBatch: any;
  urlSearchStatus: any;

  table: any;
  studentDetailsTable: any;

  excelHeaderName: any;

  photoPath: any = `${environment.API_URL_UTIL}/api/downloadFile/`;

  courses: any = [];
  dateStatus: any = [];
  searchForm = new FormGroup({
    year: new FormControl('', [
      Validators.required,
    ]),
    semester: new FormControl('', [
      Validators.required,
    ]),
    batch: new FormControl('', [
      Validators.required,
    ]),
    course: new FormControl('', [
      // Validators.required,
    ]),
  });

  editRemarkForm = new FormGroup({
    remarks: new FormControl('', [
      Validators.required,
    ]),
  });

  // assUnits: any;
  allCourses: any;
  scheduleHeader: any = [];

  constructor(private toastrService: ToastrService, public enrollmentAcceptedStudentService: EnrollmentAcceptedStudentService, public globals: Globals, private router: Router, public translate: TranslateService, private fileService: FileService, private enrollmentGroupService: EnrollmentGroupService, private coursesService: CoursesService,
    private attendance: AttendanceService, private activatedRoute: ActivatedRoute, private scoresService: ScoresService
  ) { }

  ngOnInit(): void {
    this.orgId = this.globals.currentUserInfo.orgid;
    this.username = this.globals.currentUserInfo.username;
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.currentYear = this.urlSearchYear = params['yearId'] || "";
        this.currentSemester = this.urlSearchSemester = params['semesterId'] || "";
        this.currentBatch = this.urlSearchBatch = params['batchId'] || "";
        // this.currentCourse = this.urlSearchCourse = params['courseId'] || "";

        this.searchForm.controls.year.setValue(this.currentYear);
        this.searchForm.controls.semester.setValue(this.currentSemester);
        this.searchForm.controls.batch.setValue(this.currentBatch);
        // this.searchForm.controls.course.setValue(this.currentCourse);

        this.getYears();
      });

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.updateTable();
      this.studentDetailsUpdateTable();
    });
  }

  searchFormChange() {
  }

  searchFormSubmit() {
    // console.log("submit search form");
    if (this.searchForm.valid) {
      this.Searched = true;
      this.currentYear = this.searchForm.controls.year.value;
      this.currentSemester = this.searchForm.controls.semester.value;
      this.currentBatch = this.searchForm.controls.batch.value;
      // this.currentCourse = this.searchForm.controls.course.value.length > 0 ? this.searchForm.controls.course.value : 0;

      this.loadStudentsCourses();

      // console.log("Searching form");
      // console.log(this.searchForm.value);
    } else {
      this.Searched = false;
      this.searchForm.markAllAsTouched();
      this.searchForm.markAsDirty();
    }
  }

  getYears() {
    this.enrollmentGroupService.getYears()
      .subscribe(
        data => {
          this.years = data;
          if (this.urlSearchYear != '') {

            this.getYearSemesters();
          } else {
            this.showLoader = false;
          }
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }

  getYearSemesters() {
    let year = this.searchForm.controls.year.value;
    if (year) {
      this.enrollmentGroupService.getYearSemesters(year)
        .subscribe(
          data => {
            this.semesters = data;
            if (this.urlSearchSemester != '') {
              this.getBatches();
            }
          },
          error => {
            this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          }
        );
    } else {
      this.searchForm.controls.semester.reset();
      this.semesters = [];
    }
  }

  getBatches() {
    let year = this.searchForm.controls.year.value;
    let semester = this.searchForm.controls.semester.value;
    if (year && semester) {
      this.enrollmentGroupService.getSemesterBatches(this.orgId, year, semester)
        .subscribe(
          data => {
            this.batches = data;
            // if (this.urlSearchBatch != '') {
            //   this.getBatchCourses();
            // }
            if (this.urlSearchYear != "" && this.urlSearchSemester != "" && this.urlSearchBatch != "") {
              this.Searched = true;
              this.loadStudentsCourses();
            }
          },
          error => {
            this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          }
        );
    } else {
      this.searchForm.controls.batch.reset();
      this.batches = [];
    }
  }

  // getBatchCourses() {
  //   let batch = this.searchForm.controls.batch.value;
  //   if (batch) {
  //     this.enrollmentGroupService.getBatchSubjects(this.orgId, batch)
  //       .subscribe(
  //         data => {
  //           this.courses = data;
  //           if (this.urlSearchYear != "" && this.urlSearchSemester != "" && this.urlSearchBatch != "" && this.urlSearchCourse != "") {
  //             this.Searched = true;
  //             this.loadStudentsCourses();
  //           }
  //         },
  //         error => {
  //           this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
  //         }
  //       );
  //   } else {
  //     this.searchForm.controls.group.reset();
  //     this.courses = [];
  //   }
  // }

  updateTable() {
    // $("#datatable").DataTable().destroy();
    if (this.table) {
      this.table.destroy();
    }
    setTimeout(() => {
      this.table = $("#datatable").DataTable({
        dom: 'Bfrtip',
        pagingType: 'simple_numbers',
        // responsive: true,
        columnDefs: [
          { orderable: true, targets: 0 },
          { orderable: true, targets: 1 },
          { orderable: true, targets: 2 },
          { orderable: true, targets: 4 },
          { orderable: false, targets: '_all' }
        ],
        // "columnDefs": [
        //   { "orderable": false, "targets": [1, 2] }
        // ],
        pageLength: 5,
        lengthChange: false,
        info: true,
        search: {
          searchPlaceholder: "Search",
        },
        paging: true,
        language: {
          search: "",
          searchPlaceholder: "Search",
        },
        buttons: [{
          extend: 'excelHtml5',
          text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
          titleAttr: 'enarabic',
          exportOptions: {
            columns: [0, 1, 2, 4]
          }
        }],
      });
    }, 1);

  }

  updateCourseStatus(id: number, statusId: number) {
    // Status id => (1-> RELEASE, 2 -> REJECT)
    let studentCourseObj = this.studentCoursesOriginal.filter((element: any) => element.id == id)[0];
    if (studentCourseObj && statusId == 1) {
      // Submit exam code here
      studentCourseObj.headerStatus = 'RELEASE';
      this.updateStudentCourseData(id, studentCourseObj);
    } else if (studentCourseObj && statusId == 2) {
      // Exam cancel code here
      // studentCourseObj.headerStatus = 'REJECT';
      studentCourseObj.headerStatus = 'DRAFT';
      this.updateStudentCourseData(id, studentCourseObj);
    }

  }

  updateCurrentCourseId(id: number, remarks: string = '') {
    console.log("Update current course id");
    this.editRemarkForm.reset();
    this.currentStudentCourseId = id;
    if (remarks) {
      this.editRemarkForm.controls.remarks.setValue(remarks);
    }
  }

  getKeyByValue(object: any, value: any) {
    return Object.keys(object).find(key => object[key] === value);
  }

  getStudentDetails(id: number, courseObj: any) {
    this.loadStudentDetails = true;
    this.studentDetails = [];
    this.currentCourseObj = courseObj;
    if (this.studentDetailsTable) {
      this.studentDetailsTable.destroy();
    }

    this.scoresService.getLoadStudentDetails(this.orgId, id)
      .subscribe(
        data => {
          this.studentDetails = data;
          this.loadStudentDetails = false;
        },
        error => {
          this.loadStudentDetails = false;
          this.toastrService.error(this.translate.instant('CAN_NOT_LOAD_AND_RELOAD_DATA'));
        }
      );

  }

  editRemarkFormSubmit() {
    // console.log("submit upload file form");
    if (this.editRemarkForm.valid) {
      console.log(this.editRemarkForm.value);
      let studentCourseObj = this.studentCoursesOriginal.filter((element: any) => element.id == this.currentStudentCourseId)[0];
      if (studentCourseObj) {
        studentCourseObj.remarks = this.editRemarkForm.controls.remarks.value;
        this.updateStudentCourseData(this.currentStudentCourseId, studentCourseObj, true);
      } else if (this.closeEditRemarkPopup) {
        this.closeEditRemarkPopup.nativeElement.click();
      }
      // this.handleUploadFiles();

    } else {
      this.editRemarkForm.markAllAsTouched();
      this.editRemarkForm.markAsDirty();
    }
  }

  editRemarkFormChange() { }

  // handleUploadFiles() {
  //   let formData = new FormData();

  //   let fname = this.examScoreFile.name.split('.').slice(0, -1).join('.')
  //   let fext = this.examScoreFile.name.split('.').pop()
  //   this.examScoreFileName = fname + "_" + Date.now() + "." + fext
  //   formData.append('file', this.examScoreFile, this.examScoreFileName);

  //   console.log("file name : " + this.examScoreFileName);

  //   // Call API here to upload csv file

  //   this.scoresService.uploadCSVFile(formData, this.username, this.currentStudentCourseId).subscribe(
  //     data => {
  //         if (data.sts == "SUCCESS") {
  //           if (this.globals.lang == "ar") {
  //             this.toastrService.success(data.arMsg);
  //           } else {
  //             this.toastrService.success(data.enMsg);
  //           }

  //           let examAssObj = this.studentCourses.filter((element:any)=> element.id == this.currentStudentCourseId)[0];
  //           if(examAssObj)
  //           {
  //             examAssObj.filename = this.examScoreFileName;
  //             this.updateStudentCourseData(this.currentStudentCourseId, examAssObj);
  //           }else{
  //             this.closeEditRemarkPopup.nativeElement.click();
  //           }

  //           // this.getExamScoresDataAndCoursesAndAssUnit();

  //         } else {
  //           if (this.globals.lang == "ar") {
  //             this.toastrService.error(data.arMsg);
  //           } else {
  //             this.toastrService.error(data.enMsg);
  //           }
  //         }
  //     },
  //     error => {
  //       this.toastrService.warning(this.translate.instant("CAN_NOT_UPLOAD_FILES"));
  //     }
  //   );
  // }

  // changeFile(event: any) {
  //   let typesAccept = ['application/vnd.ms-excel', 'text/csv'];
  //   // Max size 200 MEGA
  //   let maxSize = 209715200;
  //   if (event.target.files.length > 0) {
  //     var currentFile = event.target.files[0];
  //     console.log("file type: " + currentFile.type);
  //     if ((typesAccept.includes(currentFile.type)) && currentFile.size <= maxSize) {
  //       this.examScoreFile = event.target.files[0];
  //       return true;
  //     } else {
  //       this.uploadFileForm.controls.fileUpload.reset();
  //       this.uploadFileForm.controls.fileUpload.markAsDirty();
  //       this.uploadFileForm.controls.fileUpload.markAsTouched();

  //       if (currentFile.size > maxSize) {
  //         this.toastrService.error(this.translate.instant("MAX_FILE_SIZE_200_MB"))
  //       }
  //       return false;
  //     }
  //   } else {
  //     return false;
  //   }
  // }

  loadStudentsCourses() {
    this.studentCourses = [];
    // Reset URL search params
    this.urlSearchYear = '';
    this.urlSearchSemester = '';
    this.urlSearchBatch = '';
    // this.urlSearchCourse = '';

    this.showLoader = true;
    let bulkApis = [
      this.coursesService.getAllCourses(),
      this.scoresService.loadStudentCoursessubmitted(this.orgId, this.currentYear, this.currentSemester, this.currentBatch),
      // this.scoresService.searchForCourseAssUnit(this.orgId, this.currentYear, this.currentSemester, this.currentBatch, this.currentCourse),
      // this.scoresService.getAllScoreDataDetails(),
    ];

    forkJoin(bulkApis).subscribe(
      data => {
        if (typeof data[0] != undefined)
          this.allCourses = data[0];

        if (typeof data[1] != undefined && data[1].length > 0) {
          this.studentCourses = this.studentCoursesOriginal = data[1];
          // console.log(this.studentCourses);
          this.studentCourses = this.studentCourses.map((element: any) => {
            // let assUnitId = element.sbjasesid;
            let subjectid = element.subjectid;
            // let assUnit = this.assUnits.filter((i: any) => i.id == assUnitId)[0];
            let course = this.allCourses.filter((i: any) => i.id == subjectid)[0];
            return { ...element, course };
          });
          this.updateTable();
        } else {
          this.studentCourses = [];
          this.studentCoursesOriginal = [];
          this.toastrService.warning(this.translate.instant("NO_DATA_FOUND"));
        }

        this.showLoader = false;
      },
      error => {
        this.toastrService.error(this.translate.instant("CAN_NOT_GET_DATA_BE"));
        this.showLoader = false;
      }
    );
  }

  updateCourseStatusBE(id: number, status: string) {
    console.log("ID: " + id + " status: " + status);
    // this.scoresService.scrUpdateAssessmentStatus(this.orgId, id, status, this.username)
    //   .subscribe(
    //     data => {
    //       if (data.sts == "SUCCESS") {
    //         if (this.globals.lang == "ar") {
    //           this.toastrService.success(data.arMsg);
    //         } else {
    //           this.toastrService.success(data.enMsg);
    //         }
    //       } else {
    //         if (this.globals.lang == "ar") {
    //           this.toastrService.error(data.arMsg);
    //         } else {
    //           this.toastrService.error(data.enMsg);
    //         }
    //       }
    //       this.loadStudentsCourses();
    //     },
    //     error => {
    //       this.toastrService.error(this.translate.instant('FAIL_TO_UPDATE'));
    //     }
    //   );
  }

  // deleteScoreData(id: number) {
  //   this.scoresService.deleteScoreData(this.username, id)
  //     .subscribe(
  //       data => {
  //         if (data.sts == "SUCCESS") {
  //           if (this.globals.lang == "ar") {
  //             this.toastrService.success(data.arMsg);
  //           } else {
  //             this.toastrService.success(data.enMsg);
  //           }
  //         } else {
  //           if (this.globals.lang == "ar") {
  //             this.toastrService.error(data.arMsg);
  //           } else {
  //             this.toastrService.error(data.enMsg);
  //           }
  //         }
  //         this.getExamScoresDataAndCoursesAndAssUnit();
  //       },
  //       error => {
  //         this.toastrService.error(this.translate.instant('CAN_NOT_DELETE'));
  //       }
  //     );
  // }
  updateStudentCourseData(id: any, examFinalSbjObj: any, updatingRemark: boolean = false) {
    if (updatingRemark) {
      this.uploadingRemark = true;
    } else {
      this.showLoader = true;
    }
    this.scoresService.updateLoadStudentCourses(this.orgId, id, this.username, examFinalSbjObj)
      .subscribe(
        data => {
          if (data.sts == "SUCCESS") {
            if (this.globals.lang == "ar") {
              this.toastrService.success(data.arMsg);
            } else {
              this.toastrService.success(data.enMsg);
            }
          } else {
            if (this.globals.lang == "ar") {
              this.toastrService.error(data.arMsg);
            } else {
              this.toastrService.error(data.enMsg);
            }
          }
          if (this.closeEditRemarkPopup)
            this.closeEditRemarkPopup.nativeElement.click();
          this.loadStudentsCourses();
        },
        error => {
          this.toastrService.error(this.translate.instant('FAIL_TO_UPDATE'));
          this.uploadingRemark = false;
          this.showLoader = false;
        }
      );

  }

  // loadAndReloadStudent() {
  //   console.log("write load and reload API here");
  // }

  studentDetailsUpdateTable() {
    if (this.studentDetailsTable) {
      this.studentDetailsTable.destroy();
    }
    //  else { $("#datatable").DataTable().destroy(); }

    setTimeout(() => {
      this.studentDetailsTable = $("#student-details-table").DataTable({
        // columnDefs: [{
        //   orderable: false,
        //   className: 'select-checkbox',
        //   targets: 0
        // }],
        // select: {
        //   style: 'multi',
        //   selector: 'td:first-child',
        //   blurable: false
        // },
        // select: true,
        dom: 'Bfrtip',
        pagingType: 'simple_numbers',
        responsive: true,
        // columnDefs: [
        //   { responsivePriority: 1, targets: 0 },
        //   { responsivePriority: 10001, targets: 4 },
        //   { responsivePriority: 2, targets: -2 }
        // ],
        // rowReorder: true,
        // "columnDefs": [
        //   { orderable: true, className: 'reorder', targets: [0] },
        //   { orderable: false, targets: '_all' }
        // ],
        pageLength: 5,
        paging: true,
        searching: false,
        ordering: false,
        lengthChange: false,
        info: true,
        search: {
          searchPlaceholder: "Search",
        },
        language: {
          search: "",
          searchPlaceholder: "Search",
        },
        buttons: [{
          extend: 'excelHtml5',
          text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
          titleAttr: 'EXCEL',
          exportOptions: {
            columns: ':not(.notExport)'
          },
          className: 'datatable_custom_buttons',
        }],
      })
    }, 1);

  }
  exportDate() {
    var wb = XLSX.utils.table_to_book(document.getElementById('student-details-table'));
    XLSX.writeFile(wb, 'load-student-details.xlsx');
    return false;
  }
}


